export default {
  title: '經銷商管理',
  dealerList: '經銷商列表',
};
